import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuth } from '@/contexts/AuthContext'
import { useTheme } from '@/components/ThemeProvider'
import { ChevronsUpDown, User, Settings as SettingsIcon, LogOut, Sun, Moon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function HeaderUserMenu() {
  const { user, logout } = useAuth()
  const { theme, setTheme } = useTheme()
  const navigate = useNavigate()

  if (!user) return null

  const displayName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Admin'
  const displayEmail = user.email || ''

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-accent hover:text-accent-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
          <div className="w-8 h-8 rounded-full bg-muted inline-flex items-center justify-center shrink-0 md:hidden">
            <User className="h-4 w-4 text-muted-foreground" />
          </div>
          <div className="hidden md:grid flex-1 text-left text-sm leading-tight">
            <span className="truncate font-medium">{displayName}</span>
            <span className="truncate text-xs text-muted-foreground">{displayEmail}</span>
          </div>
          <ChevronsUpDown className="hidden md:block size-4 text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px] mt-1 shadow-lg shadow-black/5" sideOffset={8}>
        <DropdownMenuLabel className="font-normal px-2 space-y-1">
          <div className="text-sm font-semibold text-foreground tracking-tight break-words truncate">
            {user.firstName} {user.lastName}
          </div>
          <div className="text-xs text-muted-foreground font-medium break-words truncate">
            {user.email}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="opacity-50" />
        <DropdownMenuItem onClick={() => navigate('/settings')} className="cursor-pointer">
          <SettingsIcon className="mr-2 h-4 w-4" />
          <span>Settings</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          className="cursor-pointer"
        >
          {theme === 'dark' ? (
            <>
              <Sun className="mr-2 h-4 w-4" />
              <span>Light Mode</span>
            </>
          ) : (
            <>
              <Moon className="mr-2 h-4 w-4" />
              <span>Dark Mode</span>
            </>
          )}
        </DropdownMenuItem>
        <DropdownMenuSeparator className="opacity-50" />
        <DropdownMenuItem 
          onClick={() => logout()}
          className="cursor-pointer"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
